import React,{useState} from 'react'
import { Collapse, Table, Button, Select, Upload } from "antd"; 
const OrderHistory = () => {
    // const [labTestServicesData, setlabTestServicesData] = useState([
    //     {
    //       key: 1,
    //       servicename: "CBC",
    //       price: 400,
    //       discount: "40 %",
    //       status: "Available",
    //     },
    //     {
    //       key: 2,
    //       servicename: "LFT",
    //       price: 400,
    //       discount: "40 %",
    //       status: "Available",
    //     },
    //     {
    //       key: 3,
    //       servicename: "KFT",
    //       price: 400,
    //       discount: "40 %",
    //       status: "Unavailable",
    //     },
    //     {
    //       key: 4,
    //       servicename: "HBSAG",
    //       price: 400,
    //       discount: "40 %",
    //       status: "Unavailable",
    //     },
    //   ]);
    
      const orderHistoryColumns = [
        {
          title: "Service Name",
          dataIndex: "servicename",
          key: "servicename",
        },
        {
          title: "Price",
          dataIndex: "price",
          key: "price",
        },
        {
          title: "Customer Name",
          dataIndex: "customer",
          key: "customer",
        },
        {
          title: "Payment Status",
          dataIndex: "payment_status",
          key: "payment_status",
        },
        {
          title: "Address",
          key: "address",
          dataIndex: "address",
        }
      ];
  return (
    <div>
        <Table
              columns={orderHistoryColumns}
            //   dataSource={labTestServicesData}
              pagination={false} // Disable pagination
            />
    </div>
  )
}

export default OrderHistory;